<template>
    <div>
        <div class="lists">
            <div class="listItem" v-for="item,index in array">
                <div class="actop flx alc jsb">
                    <div class="liImage">
                        <img :src="$img(item.avatar)"></img>
                    </div>
                    <div class="liLeft">
                        <div class="liName" v-text="item.name"></div>
                        <div class="liDes" v-if="localType != 4" v-text="`${item.title}`"></div>
                        <div class="liDes" v-else v-text="`${item.title}`"></div>
                    </div>
                </div>
                <div class="acbototm flx alc">
                    <div class="acbtn" @click.stop="showReason(item)" v-if="localType == 3">
                        <img :src="$Localimg('ne5.png')" alt="" />
                        <div style="color: #FF0F23;">驳回原因</div>
                    </div>
                    <div class="acbtn" v-if="localType != 3 && localType != 4" style="margin-left: 8px;"
                        @click.stop="toCheck(item)">
                        <img :src="$Localimg('ne1.png')" alt="" />
                        <div>报名列表</div>
                    </div>
                    <div class="acbtn" @click.stop="toEdit(item)" v-if="localType != 1">
                        <img :src="$Localimg('ne2.png')" alt="" />
                        <div>活动编辑</div>
                    </div>
                    <div class="acbtn" v-if="localType != 3 && localType != 4" style="margin-left: 8px;"
                        @click.stop="toQu(item)">
                        <img :src="$Localimg('ne6.png')" alt="" />
                        <div>查看渠道</div>
                    </div>
                    <div class="acbtn" @click.stop="stopsign(item)" v-if="localType == 0">
                        <img :src="$Localimg('ne3.png')" alt="" />
                        <div v-text="item.bm_status == 1?'结束报名':'开启报名'"></div>
                    </div>
                    <div class="acbtn" @click.stop="downLine(item)" v-if="localType == 0">
                        <img :src="$Localimg('ne3.png')" alt="" />
                        <div>取消活动</div>
                    </div>
                    <div class="acbtn" @click.stop="toEdit(item)" v-if="localType == 1">
                        <img :src="$Localimg('crt.png')" alt="" />
                        <div>基于此创建</div>
                    </div>
				<!-- 	<div class="acbtn" style="margin-left: 8px;" @click.stop="downcode(item)">
					    <img :src="$Localimg('ne6.png')" alt="" />
					    <div>活动预览</div>
					</div> -->
					<div class="acbtn" style="margin-left: 8px;" @click.stop="downcode(item)" v-if="localType != 4">
					    <img :src="$Localimg('ne6.png')" alt="" />
					    <div>活动二维码</div>
					</div>
                    <div class="acbtn" @click.stop="delItem(item)" v-if="localType == 3 || localType == 4">
                        <img :src="$Localimg('ne4.png')" alt="" />
                        <div>删除</div>
                    </div>
                </div>
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :total="total"
                    :hide-on-single-page="true" :page-size="30">
                </el-pagination>
                <el-dialog title="驳回原因" :visible.sync="centerDialogVisible" width="30%" center>
                    <div style="white-space: pre-wrap;" v-text="reasons"></div>
                    <span slot="footer" class="dialog-footer">
                        <el-button round type="primary" @click="centerDialogVisible = false">我已知晓</el-button>
                    </span>
                </el-dialog>
            </div>
        </div>

        <div class="mask" v-if="show == true">
            <div class="maskContent">
                <div class="maskTitle">
                    提示
                </div>
                <div class="maskContents" v-text="word">
                </div>
                <div class="alertbtns flx alc jsb">
                    <div class="alertbtn" @click="show = false">
                        取消
                    </div>
                    <div class="alertbtn aconfri" @click="confirmThis">
                        确认
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getAcList,
        updownAc,
		getaccode
    } from "@/api/index.js"
    import {
        bus
    } from '@/bus.js'
    export default {
        name: 'acList',
        data() {
            return {
                show: false,
                centerDialogVisible: false,
                activeName: '0',
                info: {
                    level: 2
                },
                array: [],
                showLogin: false,
                page: 1,
                status: 0,
                total: 0,
                reasons: "",
                localType: this.type,
                word: "",
                curitem: {},
                ctype: ''
            };
        },
        props: ['type'],
        created() {
            this.getList()
            bus.$on('triggerPageA', () => {
                console.log(333)
                this.refreshData()
            })
        },
        beforeDestroy() {
            bus.$off('triggerPageA')
        },
        methods: {
            tostart() {

            },
			downcode(e){
				let that = this
				getaccode(e.id).then((res) => {
					if(res.code == 1){
						window.open(that.$imageUrl + res.data)
					}
				})
			},
            confirmThis() {
                let that = this
                if (that.ctype == 'edit') {
                    if (that.localType == 1) {
                        that.$router.push({
                            path: '/ActivityEdit', // 写路由path
                            query: {
                                id: that.curitem.id,
                                source: 2,
                                type:1
                            }
                        })
                    } else {
                        that.$router.push({
                            path: '/ActivityEdit', // 写路由path
                            query: {
                                id: that.curitem.id,
                                source: that.localType == 4 ? 2 : 1
                            }
                        })
                    }

                } else if (that.ctype == 'del') {
                    let data = {}
                    data.id = that.curitem.id
                    data.type = that.localType == 4 ? 4 : 3
                    updownAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.$emit("rfh")
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                } else if (that.ctype == 'oversign') {
                    let data = {}
                    data.id = that.curitem.id
                    data.type = 5
                    updownAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                } else if (that.ctype == 'downline') {
                    let data = {}
                    data.id = that.curitem.id
                    data.type = 1
                    updownAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }
            },
            refreshData() {
                let that = this
                that.localType = 4
                that.page = 1
                that.array = []
                that.getList()
                that.$emit("changeTab", 4)
            },
            toQu(e) {
                this.$router.push({
                    path: '/Channel', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            toCheck(e) {
                this.$router.push({
                    path: '/Acform', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            toEdit(e) {
                let that = this
                if (that.localType == 0) {
                    that.word = '当前活动已上线对外展示，编辑修改会重置审核状态，活动需要重新提交审核，请确定是否继续编辑？'
                }
                if (that.localType == 2) {
                    that.word = '当前活动处于审核流程中，编辑修改会重置审核状态，活动需要重新提交审核，请确定是否继续编辑？'
                }
                if (that.localType == 1) {
                    that.word = '将基于当前活动内容创建一个新活动，原活动不受影响。新活动创建后需审核通过才能上线，确定继续吗？'
                }
                if (that.localType == 3 || that.localType == 4) {
                    that.word = "请确认是否继续编辑？"
                }
                that.ctype = 'edit'
                that.curitem = e
                that.show = true
            },
            showReason(e) {
                this.reasons = e.remark
                this.centerDialogVisible = true
            },
            delItem(e) {
                let that = this
                that.ctype = 'del'
                that.curitem = e
                if (that.localType == 0) {
                    that.word = '活动对外上线中，删除会立即下线页面，全部数据永久清除、不可恢复。'
                }
                if (that.localType == 1) {
                    that.word = '活动已结束，删除将清除归档数据，数据永久清除、不可恢复。'
                }
                if (that.localType == 2) {
                    that.word = '活动正在审核中，删除会撤销审核，所有相关数据永久清除且不可恢复，请谨慎操作。'
                }
                if (that.localType == 3) {
                    that.word = '当前活动审核未通过，活动填写内容及相关数据会被彻底清除，删除后不可恢复。 是否确认删除？'
                }
                if (that.localType == 4) {
                    that.word = '该活动为草稿状态，删除后全部内容永久清除，不可恢复，确认删除？'
                }
                that.show = true

            },
            upLine(e) {
                let that = this
                let data = {}
                data.id = e.id
                data.type = 2
                that.$confirm('确定要开始该活动吗?', ' ', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updownAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            stopsign(e) {
                let that = this
                if (e.bm_status == 1) {
                    that.curitem = e
                    that.ctype = 'oversign'
                    that.word = '当前活动处于在线状态，执行结束报名操作后，将关闭报名入口。不再接收新的报名信息，已提交的报名数据会保留。 是否确认结束报名？'
                    that.show = true
                } else {
                    let data = {}
                    data.id = e.id
                    data.type = 6
                    updownAc(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }
            },
            downLine(e) {
                let that = this
                that.curitem = e
                that.ctype = 'downline'
                that.word = '当前活动处于在线状态，执行结束活动操作后，活动页面将停止对外展示。报名入口关闭，已产生的报名数据将会保留。 是否确认结束活动？'
                that.show = true
            },
            handleCurrentChange(e) {
                console.log(e)
                this.page = e
                this.getList()
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 30
                data.is_status = that.localType
                getAcList(data).then((res) => {
                    if (res.code == 1) {
                        that.show = false
                        that.array = res.data.list.data
                        that.total = res.data.list.total
                        let nums = []
                        nums.push(res.data.num1)
                        nums.push(res.data.num2)
                        nums.push(res.data.num3)
                        nums.push(res.data.num4)
                        nums.push(res.data.num5)
                        that.$emit("getNums", nums)
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    } else {
                        // that.$message.error(res.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .alertbtn {
        width: 108px;
        height: 36px;
        border-radius: 2px;
        border: 1px solid #D9D9D9;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #999999;
        cursor: pointer;
    }

    .aconfri {
        width: 108px;
        height: 36px;
        background: #007AFF;
        color: #fff;
        border-radius: 2px;
        text-align: center;
        line-height: 36px;
        border: 1px solid #007AFF;
    }

    .maskContents {
        font-size: 15px;
        color: #666666;
        margin-bottom: 20px;
        text-align: left;
    }

    .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.6);
        z-index: 7999 !important;
    }

    .maskTitle {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 10px;
        text-align: left;
    }

    .maskContent {
        width: 274px;
        background: url('https://hrxsl.com/pcImages/jlbk.png') no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding: 30px 20px 20px 20px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .acbototm {
        padding-top: 16px;
    }

    .acbtn {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #555C70;
        margin-right: 30px;
        cursor: pointer;
    }

    .acbtn img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
    }

    .actop {
        padding-bottom: 16px;
        border-bottom: 1px dashed #d8d8d8;
    }

    .liImage {
        width: 149px;
        height: 84px;
        margin-right: 12px;
    }

    .liImage img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 6px;
    }

    .liMiddle {
        margin-left: 0px;

    }

    .liLeft {
        flex: 1;
    }

    .liEdit {
        font-size: 16px;
        color: #007AFF;
    }

    .liDes {
        font-size: 14px;
        color: #999999;
        text-align: left;
    }

    .liTop {
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 28px;
        margin-bottom: 4px;
    }

    .liName {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 16px;
        text-align: left;
    }

    .liDes {
        font-size: 14px;
        color: #555C70;
    }

    .listItem {
        box-sizing: border-box;
        padding: 20px 30px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 20px;
    }

    .lists {
        box-sizing: border-box;
        padding: 0 30px 0;
        max-height: 1200px;
        overflow-y: auto;
    }

    .acctitle {
        box-sizing: border-box;
        padding: 28px 30px 0;
    }
</style>